import { render, staticRenderFns } from "./AtomModal.vue?vue&type=template&id=058677da&scoped=true&"
import script from "./AtomModal.vue?vue&type=script&lang=js&"
export * from "./AtomModal.vue?vue&type=script&lang=js&"
import style0 from "./AtomModal.vue?vue&type=style&index=0&id=058677da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058677da",
  null
  
)

export default component.exports